var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarthquake({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.258 12.023-1.15 1.71a1.042 1.042 0 0 1-.865.462h-4.2c-.576 0-1.043-.47-1.043-1.048 0-.579.467-1.048 1.044-1.048h3.645l1.897-2.822a1.041 1.041 0 0 1 1.82.164l2.423 5.523 2.538-8.226c.286-.93 1.57-.999 1.954-.105l2.347 5.466h3.288c.577 0 1.044.47 1.044 1.048 0 .579-.467 1.048-1.044 1.048h-3.974c-.417 0-.794-.249-.959-.633l-1.5-3.493-2.527 8.193c-.285.926-1.562 1-1.951.112l-2.787-6.35z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthquake);
export default __webpack_public_path__ + "static/media/earthquake.abe356e8f5eb5a5982eab5b4f9530dbd.svg";
export { ForwardRef as ReactComponent };